import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import DoneIcon from '@material-ui/icons/Done';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import MessageIcon from '@material-ui/icons/Message';
import InfoIcon from '@material-ui/icons/Info';

const styles = theme => ({
  error: {
    color: theme.palette.error.main,
  },
  warning: {
    color: theme.palette.warning.main,
  },
  success: {
    color: theme.palette.primary.main,
  },
  message: {
    color: theme.palette.secondary.main,
  },
  info: {
    color: theme.palette.neutral.medium,
  },
  textHeight: {
    lineHeight: '120%',
  },
  iconDisplay: {
    display: 'block',
    lineHeight: '120%',
  },
});

function Message({ message, classes, messageType, variant }) {
  const icons = {
    error: ErrorOutlineOutlinedIcon,
    warning: ReportProblemOutlinedIcon,
    success: DoneIcon,
    message: MessageIcon,
    info: InfoIcon,
  };
  const SpecificIcon = icons[messageType];
  return (
    <Box display="flex" direction="row" alignItems="center" alignContent="center" maxWidth="450px" textAlign="left">
      <Box mr={1}>
        <SpecificIcon className={`${classes[messageType]} ${classes.iconDisplay}`} />
      </Box>

      <Box p={1} pl={0} className={classes[messageType]}>
        <Typography variant={variant || 'body2'} className={classes.textHeight}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
}

Message.propTypes = {
  message: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    error: PropTypes.string.isRequired,
    warning: PropTypes.string.isRequired,
    success: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    textHeight: PropTypes.string.isRequired,
    iconDisplay: PropTypes.string.isRequired,
  }).isRequired,
  messageType: PropTypes.oneOf(['error', 'warning', 'success', 'info', 'message']).isRequired,
  variant: PropTypes.string,
};

Message.defaultProps = {
  variant: null,
};

export default withStyles(styles)(Message);
